import { useInfiniteQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    SearchInventoryRoNumbersInput,
    SearchInventoryRoNumbersResponse,
} from '../../types/inventory';

const PAGE_SIZE = 20;

const searchInventoryRoNumbers = async (
    sessionId: string,
    input: SearchInventoryRoNumbersInput,
): Promise<SearchInventoryRoNumbersResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/ro-numbers/search`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useSearchInventoryRoNumbers = (
    search: string = '',
    enabled: boolean = true,
    limit: number = PAGE_SIZE,
) => {
    const sessionContext = useContext(SessionContext);

    return useInfiniteQuery({
        queryKey: [
            '/inventory/ro-numbers/search',
            sessionContext?.organizationId ?? '',
            search,
            limit,
        ],
        queryFn: ({ pageParam }) =>
            searchInventoryRoNumbers(sessionContext?.sessionId ?? '', {
                search: search || undefined,
                limit,
                offset: pageParam,
            }),
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages) => {
            const loaded = allPages.reduce((sum, page) => sum + page.roNumbers.length, 0);
            if (loaded >= lastPage.totalCount) return undefined;
            if (lastPage.roNumbers.length < limit) return undefined;
            return loaded;
        },
        enabled: !!sessionContext?.sessionId && enabled,
        staleTime: 30_000,
    });
};
